import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type ReactNode, type Ref, useMemo } from 'react';
import { factoryTimeOptions } from '~/commonComponents/InputJob/Hours/Utils';

interface IArrivalTimeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  labelRight?: ReactNode;
  hasError?: boolean;
}

const Component = (
  { value, onChange, labelRight, hasError }: IArrivalTimeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const options = useMemo(
    () => factoryTimeOptions().map((o) => ({ label: o.title, value: o.value })),
    [],
  );

  return (
    <div ref={ref} data-testid="arrival-time-field" data-cy="arrival-time-field">
      <FormField label="Arrival" TrailingComponent={labelRight}>
        <InputSelectField<string>
          options={options}
          value={value}
          onChange={onChange}
          placeholder="Select Time"
          isError={Boolean(hasError)}
        />
      </FormField>
    </div>
  );
};

export const ArrivalTimeField = memo(forwardRef(Component));
